export const SkillsData = [
  {
    type: 'Data Analysis',
    list: [
      {
        name: 'R',
        icon: <i class="devicon-r-plain colored"></i>,
      },

      {
        name: 'Python',
        icon: <i class="devicon-python-plain colored"></i>,
      },
      {
        name: 'SQL',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 128 128"
          >
            <path
              fill="#d1d1d1"
              d="M51.395 24.879c-27.422 0-49.649-3.832-49.649-8.535v92.261c0 4.727 22.227 8.536 49.649 8.536c27.421 0 49.648-3.832 49.648-8.536V16.29c0 4.758-22.227 8.59-49.648 8.59Zm0 0"
            />
            <path
              fill="#adadad"
              d="M1.746 16.29v92.315c0 4.727 22.227 8.536 49.649 8.536V24.879c-27.422 0-49.649-3.832-49.649-8.59Zm92.317 4.405v92.262c4.425-1.277 6.98-2.777 6.98-4.375V16.289c0 1.633-2.547 3.106-6.98 4.406m0 0"
            />
            <path
              fill="#939699"
              d="M101.043 16.313c0-4.723-22.23-8.555-49.648-8.555c-27.422 0-49.649 3.832-49.649 8.555c0 4.726 22.227 8.558 49.649 8.558c27.417 0 49.648-3.832 49.648-8.558M1.746 74.332c0 4.727 22.227 8.535 49.649 8.535c27.421 0 49.648-3.832 49.648-8.535v6.984c0 4.723-22.227 8.532-49.648 8.532S1.746 86.016 1.746 81.316Zm0-30.75c0 4.723 22.227 8.535 49.649 8.535c27.421 0 49.648-3.836 49.648-8.535v6.98c0 4.727-22.227 8.536-49.648 8.536S1.746 55.266 1.746 50.563Zm0 0"
            />
            <path
              fill="#ecedf0"
              d="M126.64 93.09c0 16.281-13.195 29.48-29.476 29.48s-29.48-13.199-29.48-29.48s13.199-29.477 29.48-29.477s29.477 13.196 29.477 29.477Zm0 0"
            />
            <path
              fill="#3faa00"
              d="M123.004 93.09c0 14.273-11.57 25.84-25.84 25.84c-14.273 0-25.84-11.567-25.84-25.84c0-14.27 11.567-25.84 25.84-25.84c14.27 0 25.84 11.57 25.84 25.84m0 0"
            />
            <path
              fill="#fff"
              d="m88.063 105.906l24.027-13.87l-24.028-13.872Zm0 0"
            />
          </svg>
        ),
      },
      {
        name: 'Git',
        icon: <i class="devicon-git-plain colored"></i>,
      },
      {
        name: 'Excel',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 32 32"
          >
            <path
              fill="#20744a"
              fill-rule="evenodd"
              d="M28.781 4.405h-10.13V2.018L2 4.588v22.527l16.651 2.868v-3.538h10.13A1.162 1.162 0 0 0 30 25.349V5.5a1.162 1.162 0 0 0-1.219-1.095m.16 21.126H18.617l-.017-1.889h2.487v-2.2h-2.506l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2h10.411Z"
            />
            <path
              fill="#20744a"
              d="M22.487 7.439h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323z"
            />
            <path
              fill="#fff"
              fill-rule="evenodd"
              d="m6.347 10.673l2.146-.123l1.349 3.709l1.594-3.862l2.146-.123l-2.606 5.266l2.606 5.279l-2.269-.153l-1.532-4.024l-1.533 3.871l-2.085-.184l2.422-4.663z"
            />
          </svg>
        ),
      },
      {
        name: 'Tableau',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M242.69 340.3h26.62v-72.6h67v-25.82h-67v-72.6h-26.62v72.6h-66.15v25.82h66.15ZM119.26 445.18h22.59v-64.54h59.7v-20.17h-59.7v-65.34h-22.59v65.34h-59.7v20.17h59.7ZM370.15 212h22.59v-64.5h60.5v-19.37h-60.5V62.79h-22.59v65.34h-59.7v19.37h59.7ZM246.72 496h19.36v-46h41.15v-16.92h-41.15v-46h-19.36v46h-40.33V450h40.33ZM120.07 212h21v-65.31h60.51v-18.56H141V62.79h-21v65.34H59.56v18.56h60.51Zm315.65 96.84h19.36v-45.18H496v-17.74h-40.92v-45.18h-19.36v45.18h-40.33v17.74h40.33Z"
            />
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M370.15 445.18h22.59v-64.54h60.5v-20.17h-60.5v-65.34h-22.59v65.34h-59.7v20.17h59.7Z"
            />
            <path
              fill="currentColor"
              d="M307 74.08V60.37h-40.34V16h-14.52v44.37h-40.33v13.71h40.33v44.37h14.52V74.08ZM56.11 305.61h14.52v-44.37H111v-13.71H70.63V204H56.11v43.56H16v14.52l40.11-.08Z"
            />
          </svg>
        ),
      },
    ],
  },
  {
    type: 'Front-End',
    list: [
      {
        name: 'React',
        icon: <i class="devicon-react-original colored"></i>,
      },
      {
        name: 'HTML5',
        icon: <i class="devicon-html5-plain colored"></i>,
      },
      {
        name: 'JavaScript',
        icon: <i class="devicon-javascript-plain colored"></i>,
      },
      {
        name: 'Typescript',
        icon: <i class="devicon-typescript-plain colored"></i>,
      },
      {
        name: 'CSS',
        icon: <i class="devicon-css3-plain colored"></i>,
      },
    ],
  },
  {
    type: 'Back-End',
    list: [
      {
        name: 'Express',
        icon: <i class="devicon-express-original colored"></i>,
      },
      {
        name: 'Node.js',
        icon: <i class="devicon-nodejs-plain colored"></i>,
      },
    ],
  },
];
